// extracted by mini-css-extract-plugin
module.exports = {"footer":"mVp_rqCJ","relative":"_Ukf245G","footerContent":"wiSJnkch","right":"pf6zl7in","dark":"b76i3v7i","divider":"ARn8c_w2","number":"__6J7zdEA0"};